export const goBeyondProductS = {
    mainPromoHeadline:
      "products.product.promotions.goBeyond.mainPromoHeadline",
    heading: {
      image: "products.productS.promotions.goBeyond.heading.image",
      title: "products.productS.promotions.goBeyond.heading.title",
    },
    pricesBeforeAfter: {
      priceBefore:
        "products.productS.promotions.goBeyond.pricesBeforeAfter.priceBefore",
      priceAfter:
        "products.productS.promotions.goBeyond.pricesBeforeAfter.priceAfter",
    },
    footer: "products.productS.promotions.goBeyond.footer",
    total: {
      headline: "products.productS.promotions.goBeyond.total.headline",
      priceBefore: "products.productS.promotions.goBeyond.total.priceBefore",
      priceAfter: "products.productS.promotions.goBeyond.total.priceAfter",
    },
    discount: {
      heading: "products.productS.promotions.goBeyond.discount.heading",
      title: "products.productS.promotions.goBeyond.discount.title",
      amount: "products.productS.promotions.goBeyond.discount.amount",
      code: {
        description:
          "products.productS.promotions.goBeyond.discount.code.description",
        promoCode:
          "products.productS.promotions.goBeyond.discount.code.promoCode",
      },
    },
    items: {
      item1: {
        title: "products.productS.promotions.goBeyond.items.item1.title",
        description:
          "products.productS.promotions.goBeyond.items.item1.description",
        priceBefore:
          "products.productS.promotions.goBeyond.items.item1.priceBefore",
        priceAfter:
          "products.productS.promotions.goBeyond.items.item1.priceAfter",
      },
      item2: {
        title: "products.productS.promotions.goBeyond.items.item2.title",
        description:
          "products.productS.promotions.goBeyond.items.item2.description",
        priceBefore:
          "products.productS.promotions.goBeyond.items.item2.priceBefore",
        priceAfter: "products.productS.promotions.goBeyond.items.item2.priceAfter",
      },
      item3: {
        title: "products.productS.promotions.goBeyond.items.item3.title",
        description:
          "products.productS.promotions.goBeyond.items.item3.description",
        priceBefore:
          "products.productS.promotions.goBeyond.items.item3.priceBefore",
        priceAfter:
          "products.productS.promotions.goBeyond.items.item3.priceAfter",
      },
      item4: {
        title: "products.productS.promotions.goBeyond.items.item4.title",
        description:
          "products.productS.promotions.goBeyond.items.item4.description",
        priceBefore:
          "products.productS.promotions.goBeyond.items.item4.priceBefore",
        priceAfter:
          "products.productS.promotions.goBeyond.items.item4.priceAfter",
      },
      item5: {
        title: "products.productS.promotions.goBeyond.items.item5.title",
        description:
          "products.productS.promotions.goBeyond.items.item5.description",
        priceBefore:
          "products.productS.promotions.goBeyond.items.item5.priceBefore",
        priceAfter:
          "products.productS.promotions.goBeyond.items.item5.priceAfter",
      },
    },
  };
  
  export const flatrateGoBeyondProductS = {
    mainPromoHeadline:
      "products.productS.promotions.flatrateGoBeyond.mainPromoHeadline",
    heading: {
      image: "products.productS.promotions.flatrateGoBeyond.heading.image",
      title: "products.productS.promotions.flatrateGoBeyond.heading.title",
    },
    footer: "products.productS.promotions.flatrateGoBeyond.footer",
    total: {
      headline:
        "products.productS.promotions.flatrateGoBeyond.total.headline",
      priceBefore:
        "products.productS.promotions.flatrateGoBeyond.total.priceBefore",
      priceAfter:
        "products.productS.promotions.flatrateGoBeyond.total.priceAfter",
    },
    discount: {
      heading: "products.productS.promotions.goBeyond.discount.heading",
      title: "products.productS.promotions.flatrateGoBeyond.discount.title",
      amount: "products.productS.promotions.flatrateGoBeyond.discount.amount",
      code: {
        description:
          "products.productS.promotions.flatrateGoBeyond.discount.code.description",
        promoCode:
          "products.productS.promotions.flatrateGoBeyond.discount.code.promoCode",
      },
    },
    items: {
      item1: {
        title:
          "products.productS.promotions.flatrateGoBeyond.items.item1.title",
        description:
          "products.productS.promotions.flatrateGoBeyond.items.item1.description",
        priceBefore:
          "products.productS.promotions.flatrateGoBeyond.items.item1.priceBefore",
        priceAfter:
          "products.productS.promotions.flatrateGoBeyond.items.item1.priceAfter",
      },
      item2: {
        title:
          "products.productS.promotions.flatrateGoBeyond.items.item2.title",
        description:
          "products.productS.promotions.flatrateGoBeyond.items.item2.description",
        priceBefore:
          "products.productS.promotions.flatrateGoBeyond.items.item2.priceBefore",
        priceAfter:
          "products.productS.promotions.flatrateGoBeyond.items.item2.priceAfter",
      },
      item3: {
        title:
          "products.productS.promotions.flatrateGoBeyond.items.item3.title",
        description:
          "products.productS.promotions.flatrateGoBeyond.items.item3.description",
        priceBefore:
          "products.productS.promotions.flatrateGoBeyond.items.item3.priceBefore",
        priceAfter:
          "products.productS.promotions.flatrateGoBeyond.items.item3.priceAfter",
      },
      item4: {
        title:
          "products.productS.promotions.flatrateGoBeyond.items.item4.title",
        description:
          "products.productS.promotions.flatrateGoBeyond.items.item4.description",
        priceBefore:
          "products.productS.promotions.flatrateGoBeyond.items.item4.priceBefore",
        priceAfter:
          "products.productS.promotions.flatrateGoBeyond.items.item4.priceAfter",
      },
      item5: {
        title:
          "products.productS.promotions.flatrateGoBeyond.items.item5.title",
        description:
          "products.productS.promotions.flatrateGoBeyond.items.item5.description",
        priceBefore:
          "products.productS.promotions.flatrateGoBeyond.items.item5.priceBefore",
        priceAfter:
          "products.productS.promotions.flatrateGoBeyond.items.item5.priceAfter",
      },
      item6: {
        title:
          "products.productS.promotions.flatrateGoBeyond.items.item6.title",
        description:
          "products.productS.promotions.flatrateGoBeyond.items.item6.description",
        priceBefore:
          "products.productS.promotions.flatrateGoBeyond.items.item6.priceBefore",
        priceAfter:
          "products.productS.promotions.flatrateGoBeyond.items.item6.priceAfter",
      },
    },
  };
  
  export const goBeyondProductX = {
    mainPromoHeadline:
      "products.productX.promotions.goBeyond.mainPromoHeadline",
    heading: {
      image: "products.productX.promotions.goBeyond.heading.image",
      title: "products.productX.promotions.goBeyond.heading.title",
    },
    pricesBeforeAfter: {
      priceBefore:
        "products.productX.promotions.goBeyond.pricesBeforeAfter.priceBefore",
      priceAfter:
        "products.productX.promotions.goBeyond.pricesBeforeAfter.priceAfter",
    },
    footer: "products.productX.promotions.goBeyond.footer",
    total: {
      headline: "products.productX.promotions.goBeyond.total.headline",
      priceBefore: "products.productX.promotions.goBeyond.total.priceBefore",
      priceAfter: "products.productX.promotions.goBeyond.total.priceAfter",
    },
    discount: {
      heading: "products.productX.promotions.goBeyond.discount.heading",
      title: "products.productX.promotions.goBeyond.discount.title",
      amount: "products.productX.promotions.goBeyond.discount.amount",
      code: {
        description:
          "products.productX.promotions.goBeyond.discount.code.description",
        promoCode:
          "products.productX.promotions.goBeyond.discount.code.promoCode",
      },
    },
    items: {
      item1: {
        title: "products.productX.promotions.goBeyond.items.item1.title",
        description:
          "products.productX.promotions.goBeyond.items.item1.description",
        priceBefore:
          "products.productX.promotions.goBeyond.items.item1.priceBefore",
        priceAfter:
          "products.productX.promotions.goBeyond.items.item1.priceAfter",
      },
      item2: {
        title: "products.productX.promotions.goBeyond.items.item2.title",
        description:
          "products.productX.promotions.goBeyond.items.item2.description",
        priceBefore:
          "products.productX.promotions.goBeyond.items.item2.priceBefore",
        priceAfter: "products.productX.promotions.goBeyond.items.item2.priceAfter",
      },
      item3: {
        title: "products.productX.promotions.goBeyond.items.item3.title",
        description:
          "products.productX.promotions.goBeyond.items.item3.description",
        priceBefore:
          "products.productX.promotions.goBeyond.items.item3.priceBefore",
        priceAfter:
          "products.productX.promotions.goBeyond.items.item3.priceAfter",
      },
      item4: {
        title: "products.productX.promotions.goBeyond.items.item4.title",
        description:
          "products.productX.promotions.goBeyond.items.item4.description",
        priceBefore:
          "products.productX.promotions.goBeyond.items.item4.priceBefore",
        priceAfter:
          "products.productX.promotions.goBeyond.items.item4.priceAfter",
      },
      item5: {
        title: "products.productX.promotions.goBeyond.items.item5.title",
        description:
          "products.productX.promotions.goBeyond.items.item5.description",
        priceBefore:
          "products.productX.promotions.goBeyond.items.item5.priceBefore",
        priceAfter:
          "products.productX.promotions.goBeyond.items.item5.priceAfter",
      },
    },
  };
  
  export const flatrateGoBeyondProductX = {
    mainPromoHeadline:
      "products.productX.promotions.flatrateGoBeyond.mainPromoHeadline",
    heading: {
      image: "products.productX.promotions.flatrateGoBeyond.heading.image",
      title: "products.productX.promotions.flatrateGoBeyond.heading.title",
    },
    footer: "products.productX.promotions.flatrateGoBeyond.footer",
    total: {
      headline:
        "products.productX.promotions.flatrateGoBeyond.total.headline",
      priceBefore:
        "products.productX.promotions.flatrateGoBeyond.total.priceBefore",
      priceAfter:
        "products.productX.promotions.flatrateGoBeyond.total.priceAfter",
    },
    discount: {
      heading: "products.productX.promotions.goBeyond.discount.heading",
      title: "products.productX.promotions.flatrateGoBeyond.discount.title",
      amount: "products.productX.promotions.flatrateGoBeyond.discount.amount",
      code: {
        description:
          "products.productX.promotions.flatrateGoBeyond.discount.code.description",
        promoCode:
          "products.productX.promotions.flatrateGoBeyond.discount.code.promoCode",
      },
    },
    items: {
      item1: {
        title:
          "products.productX.promotions.flatrateGoBeyond.items.item1.title",
        description:
          "products.productX.promotions.flatrateGoBeyond.items.item1.description",
        priceBefore:
          "products.productX.promotions.flatrateGoBeyond.items.item1.priceBefore",
        priceAfter:
          "products.productX.promotions.flatrateGoBeyond.items.item1.priceAfter",
      },
      item2: {
        title:
          "products.productX.promotions.flatrateGoBeyond.items.item2.title",
        description:
          "products.productX.promotions.flatrateGoBeyond.items.item2.description",
        priceBefore:
          "products.productX.promotions.flatrateGoBeyond.items.item2.priceBefore",
        priceAfter:
          "products.productX.promotions.flatrateGoBeyond.items.item2.priceAfter",
      },
      item3: {
        title:
          "products.productX.promotions.flatrateGoBeyond.items.item3.title",
        description:
          "products.productX.promotions.flatrateGoBeyond.items.item3.description",
        priceBefore:
          "products.productX.promotions.flatrateGoBeyond.items.item3.priceBefore",
        priceAfter:
          "products.productX.promotions.flatrateGoBeyond.items.item3.priceAfter",
      },
      item4: {
        title:
          "products.productX.promotions.flatrateGoBeyond.items.item4.title",
        description:
          "products.productX.promotions.flatrateGoBeyond.items.item4.description",
        priceBefore:
          "products.productX.promotions.flatrateGoBeyond.items.item4.priceBefore",
        priceAfter:
          "products.productX.promotions.flatrateGoBeyond.items.item4.priceAfter",
      },
      item5: {
        title:
          "products.productX.promotions.flatrateGoBeyond.items.item5.title",
        description:
          "products.productX.promotions.flatrateGoBeyond.items.item5.description",
        priceBefore:
          "products.productX.promotions.flatrateGoBeyond.items.item5.priceBefore",
        priceAfter:
          "products.productX.promotions.flatrateGoBeyond.items.item5.priceAfter",
      },
      item6: {
        title:
          "products.productX.promotions.flatrateGoBeyond.items.item6.title",
        description:
          "products.productX.promotions.flatrateGoBeyond.items.item6.description",
        priceBefore:
          "products.productX.promotions.flatrateGoBeyond.items.item6.priceBefore",
        priceAfter:
          "products.productX.promotions.flatrateGoBeyond.items.item6.priceAfter",
      },
    },
  };
  